import { Core } from "@faire/design-tokens";
import { INPUT_HEIGHT, inputStyles, InputWrapper, inputBorderStyles } from "@faire/web--source/slate/Input";
import { Row } from "@faire/web--source/slate/Layout";
import { Span, TypographyStyles } from "@faire/web--source/slate/Typography";
import { highVisSlateComponent, HIGH_VIS_FILTER } from "@faire/web--source/slate/utils/highVisSlateComponent";
import styled, { css } from "styled-components";
import { DROPDOWN_LIST_HEIGHT } from "./constants";
export var MobileChevronWrapper = styled.div.withConfig({
    componentId: "sc-1a4e5ff1-0"
})([
    "position:absolute;pointer-events:none;right:16px;top:50%;transform:translateY(-50%);"
]);
export var Wrapper = styled.div.withConfig({
    componentId: "sc-1a4e5ff1-1"
})([
    "display:flex;flex-direction:column;align-items:stretch;position:relative;",
    "{cursor:pointer;}input{",
    ";}",
    ""
], InputWrapper, function(props) {
    return props.$disableInput && !props.$disabled ? css([
        "color:transparent;text-shadow:0 0 0 ",
        ";"
    ], Core.surface.default) : "";
}, highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
export var MobileSelectWrapper = styled.div.withConfig({
    componentId: "sc-1a4e5ff1-2"
})([
    "display:flex;flex-direction:column;width:100%;"
]);
export var MobileInnerWrapper = styled.div.withConfig({
    componentId: "sc-1a4e5ff1-3"
})([
    "position:relative;display:flex;flex:1;align-items:center;width:100%;min-height:42px;",
    ";",
    ";padding:0;background-color:",
    ";"
], inputStyles, function(param) {
    var $borderless = param.$borderless;
    return $borderless ? "none" : inputBorderStyles;
}, function(param) {
    var $disabled = param.$disabled;
    return $disabled ? Core.surface.subdued : Core.surface.inverse;
});
export var StyledSelect = styled.select.withConfig({
    componentId: "sc-1a4e5ff1-4"
})([
    "",
    ";display:flex;align-items:center;appearance:none;border-radius:0;width:100%;padding-right:35px;padding-left:16px;border:none;appearance:none;outline:none;background-color:transparent;"
], TypographyStyles({
    as: undefined
}));
export var DropdownWrapper = styled.div.withConfig({
    componentId: "sc-1a4e5ff1-5"
})([
    "display:block;width:100%;height:auto;max-height:",
    "px;background-color:",
    ";border:solid 1px ",
    ";position:absolute;overflow:auto;z-index:2;box-sizing:border-box;",
    ""
], DROPDOWN_LIST_HEIGHT, Core.surface.inverse, Core.border.muted, function(param) {
    var _param_$isPortal = param.$isPortal, $isPortal = _param_$isPortal === void 0 ? false : _param_$isPortal, $isUp = param.$isUp, theme = param.theme, $showErrorMessage = param.$showErrorMessage, $hasHelper = param.$hasHelper;
    var _theme_fonts_sansSerif_p, _theme_fonts_sansSerif, _theme_fonts;
    if ($isPortal) {
        return "";
    }
    return css([
        "",
        " bottom:",
        ";transform:translate(0,",
        ");"
    ], $isUp ? "border-bottom: 0;" : "border-top: 0;", $showErrorMessage || $hasHelper ? theme === null || theme === void 0 ? void 0 : (_theme_fonts = theme.fonts) === null || _theme_fonts === void 0 ? void 0 : (_theme_fonts_sansSerif = _theme_fonts.sansSerif) === null || _theme_fonts_sansSerif === void 0 ? void 0 : (_theme_fonts_sansSerif_p = _theme_fonts_sansSerif.p) === null || _theme_fonts_sansSerif_p === void 0 ? void 0 : _theme_fonts_sansSerif_p.lineHeight : "0", $isUp ? css([
        "-",
        "px"
    ], INPUT_HEIGHT + 2) : "100%");
});
export var OptionRow = styled(Row).withConfig({
    componentId: "sc-1a4e5ff1-6"
})([
    "min-height:44px;cursor:pointer;border:0;user-select:none;background:transparent;",
    ""
], function(param) {
    var highlight = param.$highlight;
    return highlight ? css([
        "background-color:",
        ";"
    ], Core.surface.subdued) : "";
});
export var DropdownItem = styled.button.withConfig({
    componentId: "sc-1a4e5ff1-7"
})([
    "min-height:44px;border:0;user-select:none;background:transparent;width:100%;display:block;cursor:pointer;",
    " text-align:left;padding:12px 15px;",
    ";&:disabled{color:",
    ";background-color:",
    ";}"
], function(param) {
    var theme = param.theme;
    var _theme_input_label_color;
    return TypographyStyles({
        color: (_theme_input_label_color = theme.input.label.color) !== null && _theme_input_label_color !== void 0 ? _theme_input_label_color : Core.text.default
    });
}, function(param) {
    var $highlight = param.$highlight;
    return $highlight ? css([
        "background-color:",
        ";"
    ], Core.surface.subdued) : "";
}, function(param) {
    var theme = param.theme;
    return theme.text.disabled;
}, Core.surface.muted);
export var EditOptionButton = styled.button.withConfig({
    componentId: "sc-1a4e5ff1-8"
})([
    "",
    ";padding:12px 15px;",
    ""
], function(param) {
    var theme = param.theme;
    var _theme_input_label_color;
    return TypographyStyles({
        color: (_theme_input_label_color = theme.input.label.color) !== null && _theme_input_label_color !== void 0 ? _theme_input_label_color : Core.text.default
    });
}, function(param) {
    var $highlight = param.$highlight;
    return $highlight ? css([
        "background-color:",
        ";"
    ], Core.surface.subdued) : "";
});
export var CustomEditSpan = styled(Span).withConfig({
    componentId: "sc-1a4e5ff1-9"
})([
    "text-decoration:underline;&:hover{color:",
    ";}"
], Core.text.enabled);
export var CreateNewOptionDropdownItem = styled(DropdownItem).withConfig({
    componentId: "sc-1a4e5ff1-10"
})([
    "align-items:center;border-top:1px solid ",
    ";padding:12px 16px;"
], Core.border.muted);
export var CloseWrapper = styled.button.withConfig({
    componentId: "sc-1a4e5ff1-11"
})([
    "font-size:16px;display:flex;width:42px;height:42px;left:calc(100% - 42px);position:absolute;bottom:",
    "px;align-items:center;justify-content:center;"
], function(param) {
    var $hasHelperText = param.$hasHelperText;
    return $hasHelperText ? 20 : 0;
});
